import Swal from "sweetalert2";
import { apicall } from "../Integration/apicall";
import { deletecontactinfo } from "./mutation";

export const CompanyState = {
  //    section 1
  companyName: "",
  address1: "",
  address2: "",
  pincode: "",

  country: "",
  state: "",
  city: "",

  //   section2
  incorporationDate: "",

//   finacial: "",
  ownershipType: "",

  //section 3

  gstNumber: "",
  cinNumber: "",
  ifscCode: "",

  //section 4
  contactInfo: [
    {
      salutation: "",
      name: "",
      designation: "",
      phoneNumber: "",
      email: "",

      salutationStatus: "unchecked",
      nameStatus: "unchecked",
      designationStatus: "unchecked",
      phoneNumberStatus: "unchecked",
      emailStatus: "unchecked",
    },
  ],

  //status
  companyNameStatus: "unchecked",
  countryStatus: "unchecked",
  stateStatus: "unchecked",
  cityStatus: "unchecked",
  incorporationDateStatus: "unchecked",
  pincodeStatus:"unchecked",
  ownershipTypeStatus:"unchecked",
  address1Status: "unchecked",
  address2Status: "unchecked",
  gstNumberStatus: "unchecked",
  cinNumberStatus: "unchecked",
  ifscCodeStatus: "unchecked",
};

export const handlechange = (currentstate, action) => {
  console.log("trigered", action);

  const { field, value, index, arrayfield,method,edit=false } = action;

  const updatedstate = { ...currentstate };
    if(method ==="add"){
       updatedstate?.contactInfo?.push({
              salutation: "",
      name: "",
      designation: "",
      phoneNumber: "",
      email: "",

      salutationStatus: "unchecked",
      nameStatus: "unchecked",
      designationStatus: "unchecked",
      phoneNumberStatus: "unchecked",
      emailStatus: "unchecked",
       })
       return updatedstate;
    }
   else if(method==="delete"){
    const contactinforowid = updatedstate.contactInfo[index]?.id||-1
    console.log(contactinforowid,"rowid");
    
  if(edit && contactinforowid>0){
   console.log(updatedstate.contactInfo[index]?.id,"upddstatee");
  const id = updatedstate.contactInfo[index]?.id
      
    apicall(deletecontactinfo,{id}).then((res)=>{
     const success = res.data.data.deleteContact.success
     const message = res.data.data.deleteContact.message
      Swal.fire({
               position: "center",
               icon: success?"success":"error",
               title: message,
               showConfirmButton: false,
               timer: 2500,
             })
    }
    ).catch((err)=>{
       Swal.fire({
               position: "center",
               icon: "error",
               title: "Delete After Sometime !",
               showConfirmButton: false,
               timer: 2500,
             })
    })
    
  }
   updatedstate.contactInfo.splice(index,1)
  return updatedstate;
    }

 else if (field != "contactInfo" && field!="id") {
    console.log("inside info");

    updatedstate[field] = value;
    console.log(updatedstate, "beforeupdstate");

  }

  switch (field) {
    case "companyName": {
        console.log(value && value.length<3,"incompany");
        
        if(value.length>3){
         updatedstate[field+"Status"] ="success"
        }
        else if(value && value.length<=3){
            console.log("inside elseif");
            
         updatedstate[field+"Status"] ="error"
         console.log(updatedstate,"upd in elseif");
         
        }
        else{
       updatedstate[field+"Status"] ="unchecked"
        }
       break
    }

    case"incorporationDate":{
       const today = new Date();
  const inputDate = new Date(value);

  if (value && inputDate instanceof Date && !isNaN(inputDate) && inputDate <= today) {
    updatedstate[field + "Status"] = "success";
  } else {
    updatedstate[field + "Status"] = "error";
  }
      break
    }
    case "ownershipType":{
         updatedstate[field + "Status"] = value ? "success" : "error";
            break
    }
   case "gstNumber":{
    const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

  if (value && gstRegex.test(value)) {
    updatedstate[field + "Status"] = "success";
  } else {
    updatedstate[field + "Status"]= "error";
  }
     break
   }
   case "cinNumber":{
    const cinRegex = /^[A-Z]{1}[0-9]{5}[A-Z]{2}[0-9]{4}[A-Z]{3}[0-9]{6}$/;

  if (value && cinRegex.test(value)) {
    updatedstate[field + "Status"] = "success";
  } else {
    updatedstate[field + "Status"] = "error";
  }
     break
   }

   case "ifscCode":{
     const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;

  if (value && ifscRegex.test(value)) {
    updatedstate[field + "Status"]= "success";
  } else {
    updatedstate[field + "Status"] = "error";
  }
     break
   }

    case "address1": {
        if(value.length>3){
         updatedstate[field+"Status"] ="success"
        }
        else if(value && value.length<=3){
         updatedstate[field+"Status"] ="error"
        }
        else{
       updatedstate[field+"Status"] ="unchecked"
        }
           break
    }

    case "address2": {
        if(value.length>3){
         updatedstate[field+"Status"] ="success"
        }
        else if(value && value.length<=3){
         updatedstate[field+"Status"] ="error"
        }
        else{
       updatedstate[field+"Status"] ="unchecked"
        }
           break
    }

    case "pincode": {
        const pincodeRegex = /^[1-9][0-9]{5}$/; // starts with 1-9 and has exactly 6 digits

  if (value && pincodeRegex.test(value)) {
    updatedstate[field + "Status"] = "success";
  } else {
    updatedstate[field + "Status"]= "error";
  }
     break
    }

    case "country": {
        if(value){
            updatedstate[field+"Status"] = "success"
        }
        else{
            updatedstate[field+"Status"] ="unchecked"
        }
           break
    }

    case "state": {
           if(value){
            updatedstate[field+"Status"] = "success"
        }
        else{
            updatedstate[field+"Status"] ="unchecked"
        }
           break
    }

       case "city": {
           if(value){
            updatedstate[field+"Status"] = "success"
        }
        else{
            updatedstate[field+"Status"] ="unchecked"
        }
           break
    }

    case "contactInfo":
      {
        if (field === "contactInfo") {
         console.log(value,"inddata");
         
          if (!updatedstate[field]) updatedstate[field] = [];
if (!updatedstate[field][index]) updatedstate[field][index] = {};
          updatedstate[field][index][arrayfield] = value;

          if(arrayfield==="salutation"){
           if(value){
            updatedstate[field][index][arrayfield+"Status"] ="success"
           }
           else{
         updatedstate[field][index][arrayfield+"Status"] ="unchecked"
           }
          }
           else if(arrayfield==="name"){
            if(value.length>3){
          updatedstate[field][index][arrayfield+"Status"] ="success"
        }
        else if(value && value<3){
         updatedstate[field][index][arrayfield+"Status"] ="error"
        }
        else{
        updatedstate[field][index][arrayfield+"Status"] ="unchecked"
        }
          }

           else if(arrayfield==="designation"){
             if(value){
             updatedstate[field][index][arrayfield+"Status"] ="success"
           }
           else{
         updatedstate[field][index][arrayfield+"Status"] ="unchecked"
           }

          }
           else if(arrayfield==="phoneNumber"){
            const phoneRegex = /^[6-9]\d{9}$/; // Validates Indian 10-digit numbers starting from 6-9

  if (value && phoneRegex.test(value)) {
     updatedstate[field][index][arrayfield+"Status"] = "success";
  } else {
     updatedstate[field][index][arrayfield+"Status"] = "error";
  }
          }
          else{
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (value && emailRegex.test(value)) {
     updatedstate[field][index][arrayfield+"Status"] = "success";
  } else {
    updatedstate[field][index][arrayfield+"Status"] = "error";
  }
          }
        }
           break
      }

     

      
  }
  return updatedstate;
};
